import { render, staticRenderFns } from "./PlaylistPicker.vue?vue&type=template&id=974a1636&scoped=true&"
import script from "./PlaylistPicker.vue?vue&type=script&lang=js&"
export * from "./PlaylistPicker.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistPicker.vue?vue&type=style&index=0&id=974a1636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974a1636",
  null
  
)

export default component.exports